<template>
  <div class="div-form">
    <el-card class="el-card">
      <p style="font-size: 25px;position: absolute;left: 20px;top: 6px">修改密码</p>
      <hr class="line">
      <el-form class="el-form" ref="form" :model="form" label-width="80px">
        <el-form-item label="用户名">
          <el-input placeholder="请输入用户名" v-model="form.username" style="width: 300px;position: absolute;left: 50px"></el-input>
        </el-form-item>
        <el-form-item label="旧密码">
          <el-input placeholder="请输入旧密码" v-model="form.old_password" style="width: 300px;position: absolute;left: 50px"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input placeholder="请输入新密码" v-model="form.new_password" style="width: 300px;position: absolute;left: 50px"></el-input>
        </el-form-item>
        <el-button type="info" style="position: absolute;left: 340px;top: 235px" @click="returna">取消</el-button>
        <el-button type="success" style="position: absolute;left: 430px;top: 235px" @click="updatePassword">确定</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      form: {
        username: '',
        old_password:'',
        new_password:''
      }
    }
  },
  methods: {
    //修改个人密码
    updatePassword(){
      axios.post("/otherApi/manager/changePassword/",{
          username : this.form.username,
          old_password : this.form.old_password,
          new_password : this.form.new_password
      }).then(res =>{
        console.log(res)
        if (res.data.code === 200){
          this.$message.success('修改成功!');
          this.$router.push('/')
        }else {
          this.$message.error('修改失败,请确认用户名和旧密码');
        }
      })
    },
    returna(){
      this.$message.success('回到主页');
      this.$router.push('/menu/userNewHome')
    }
  }
}
</script>

<style scoped>
.div-form{
  position: relative;
  top: 120px;
  left: -50px;
}
.el-card{
  background-color: rgb(16,163,127);
  width: 610px;
  height: 400px;
}
.el-form{
  position: absolute;
  top: 100px;
}
.line{
  color:grey;
  position: relative;
  top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/UpdatePassword.vue